/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VrfContextModule
 */

import { IGatewayMonitor } from 'generated-types';
import { GatewayMonitor } from 'object-types';
import { IpAddrConfigItem } from 'ajs/modules/data-model/factories/ip-addr.config-item.factory';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

type IGatewayMonitorConfigPartial = Omit<IGatewayMonitor, 'gateway_ip'>;

interface IGatewayMonitorConfig extends IGatewayMonitorConfigPartial {
    gateway_ip: IpAddrConfigItem;
}

/**
 * @description Gateway Monitor Message Item.
 * @author Alex Klyuev
 */
export class GatewayMonitorConfigItem extends MessageItem<IGatewayMonitorConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: GatewayMonitor,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * @override
     */
    protected requiredFields(): string[] {
        return [
            'gateway_ip',
        ];
    }
}
